<template>
  <div class="contest-image-preview card">
    <div class="image-detail-header">
      <svg @click="close" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
           class="bi bi-x selectable" viewBox="0 0 16 16">
        <path
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
      </svg>
    </div>
    <div class="image-control-container">
      <div class="image-selector-container">
        <svg @click="lastImage" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="gray"
             class="bi bi-caret-left-fill selectable" viewBox="0 0 16 16">
          <path
              d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
        </svg>
      </div>
      <img v-if="resolvedImageUrl" :src="resolvedImageUrl" :alt="id" class="contest-image-preview-image">
      <div class="image-selector-container">
        <svg @click="nextImage" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="gray"
             class="bi bi-caret-right-fill selectable" viewBox="0 0 16 16">
          <path
              d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
        </svg>
      </div>
    </div>
    <div class="image-detail-footer" v-if="image">
      <h3>{{ image.image_name }}</h3>
      <p>Votes: <strong>{{ votes.votes }}</strong></p>
      <button v-if="!voted" class="button-secondary" @click="voteForImage">Vote</button>
    </div>
  </div>

</template>

<script setup>
import apiService from '@/services/apiService'
import {onBeforeUnmount, onMounted, ref, watch} from 'vue'

const props = defineProps({
  id: Number,
  contest_id: String,
  voted: Boolean
})

const resolvedImageUrl = ref(null)
let votes = ref(0);
let image = ref(null);

const emit = defineEmits(['close', 'next', 'last', 'vote'])

function close() {
  emit('close');
}

function nextImage() {
  emit('next');
}

function lastImage() {
  emit('last');
}

function voteForImage() {
  emit('vote', props.id)
}

async function loadImageAndVotes(imageId) {
  const image_res = await apiService.getImage(imageId);
  image.value = image_res;

  const response = await apiService.getImageSignedUrl(imageId)
  resolvedImageUrl.value = response.url

  const vote_res = await apiService.getVotesForImageInContest(props.contest_id, imageId)
  votes.value = vote_res
}

// Load on mount
onMounted(() => {
  loadImageAndVotes(props.id)
})

// Reload whenever the ID prop changes
watch(() => props.id, (newId) => {
  if (newId) {
    loadImageAndVotes(newId)
  }
})
</script>

<style scoped>
.contest-image-preview {
  width: 60%;
  max-height: 80vh;
}

.image-detail-header {
  display: flex;
  justify-content: end;
  align-items: center;
}

.image-control-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contest-image-preview-image {
  width: 95%;
  height: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
}

.image-detail-footer {
  display: flex;
  align-items: baseline;
  justify-content: start;
  gap: 2rem;
  margin-left: 2rem;
}
</style>